import { z } from 'zod';
export const pendingOrganizationDeletionSchema = z.discriminatedUnion('pending', [
    z.object({ pending: z.literal(false), deletionAvailable: z.boolean() }),
    z.object({
        pending: z.literal(true),
        id: z.string(),
        name: z.string(),
        deletedAt: z.string(),
        recoverUntil: z.string(),
        daysRemaining: z.number().int().nonnegative(),
        canRestore: z.boolean(),
    }),
]);
export const organizationDeletionRequestedSchema = z.object({
    success: z.literal(true),
    deletedOrganizationId: z.string(),
});
export const deletedItemRestoredSchema = z.object({
    restored: z.literal(true),
    childrenRestored: z.number().int().nonnegative(),
    passwordResetRequired: z.boolean().optional(),
});
export const organizationDeletionSummarySchema = z.object({
    deletionAvailable: z.boolean(),
    id: z.string(),
    name: z.string(),
    customers: z.number().int().nonnegative(),
    conversations: z.number().int().nonnegative(),
    appointments: z.number().int().nonnegative(),
    documents: z.number().int().nonnegative(),
    staff: z.number().int().nonnegative(),
});
//# sourceMappingURL=privacy.js.map